<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg4 md4 sm12>
                    <h-currency-input v-model="configuration.Currency" label="Tỷ giá CNY" :decimal="0" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg8 md8 sm12>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-textarea
                        v-model="configuration.UnitListVI"
                        label="Danh sách đơn vị tính (VI)"
                        placeholder="Nhập danh sách, các phần tử cách nhau dấu phẩy (ví dụ: cái, bộ, hộp, kg, chiếc, đôi)"
                        outlined
                        dense
                        rows="3"
                        hide-details="auto"
                    ></v-textarea>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-textarea
                        v-model="configuration.UnitListEN"
                        label="Danh sách đơn vị tính (EN)"
                        placeholder="Nhập danh sách, các phần tử cách nhau dấu phẩy (ví dụ: pcs, set, box, kg, pair, carton)"
                        outlined
                        dense
                        rows="3"
                        hide-details="auto"
                    ></v-textarea>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";

export default {
    computed: {
        ...mapState({
            loading: state => state.configuration.loading,
            configuration: state => state.configuration.selected
        })
    },
    methods: {
        refreshData() {
            this.$store.dispatch("configuration/getDetail", 1);
        },
        saveData() {
            const payloadData = this.configuration || {};
            const configId = payloadData.ID || 1;
            payloadData.ID = configId;
            this.$store.dispatch("configuration/setDetail", {
                data: payloadData,
                id: configId
            });
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.configuration.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
